module.exports = __webpack_public_path__ + "img/p25.4f5c6792.png";